import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'

import { filter } from 'styles/colors'
import { CUSTOMER, CONSULTANT, ADMIN } from 'userTypes'

import Header from 'components/Header'
import Index from 'pages/Index'
import LogIn from 'pages/LogIn'
import Register from 'pages/Register'
import Saved from 'pages/Saved'
import Consultant from 'pages/Consultant'
import User from 'pages/User'
import Chat from 'pages/Chat'
import Settings from 'pages/Settings'
import Profile from 'pages/Profile'
import ResetPassword from 'pages/ResetPassword'
import PrivateRoute from './PrivateRoute'
import NotFound from 'pages/NotFound'
import Unlisted from 'pages/Unlisted'

const BodyWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const Wrapper = styled.div`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

const Filter = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${filter};
`

const ModalSwitch = ({ searchFocused }) => (
  <BodyWrapper>
    <Header />
    <Wrapper>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route path="/login" component={LogIn} />
        <Route path="/register" component={Register} />
        <Route path="/resetPassword" component={ResetPassword} />

        <PrivateRoute
          path="/saved"
          component={Saved}
          userTypes={[CUSTOMER, CONSULTANT]}
        />
        <PrivateRoute
          path="/consultants/:consultantId"
          component={Consultant}
          userTypes={[CUSTOMER, ADMIN, CONSULTANT]}
        />
        <PrivateRoute
          path="/users/:userId"
          component={User}
          userTypes={[CUSTOMER, ADMIN, CONSULTANT]}
        />
        <PrivateRoute
          path="/chat"
          component={Chat}
          userTypes={[CUSTOMER, CONSULTANT, ADMIN]}
        />
        <PrivateRoute
          path="/settings"
          component={Settings}
          userTypes={[CUSTOMER, CONSULTANT, ADMIN]}
        />
        <PrivateRoute
          path="/profile"
          component={Profile}
          userTypes={[CUSTOMER, ADMIN, CONSULTANT]}
        />
        <PrivateRoute
          path="/unlisted"
          component={Unlisted}
          userTypes={[ADMIN]}
        />

        <Route path="*" component={NotFound} />
      </Switch>
      {searchFocused && <Filter />}
    </Wrapper>
  </BodyWrapper>
)

const mapStateToProps = state => ({ searchFocused: state.search.focus })

export default connect(mapStateToProps)(ModalSwitch)



// WEBPACK FOOTER //
// ./src/Router/ModalSwitch.js